export default "__VITE_ASSET__005a0912__"